
export class Routers {
    path: string;
}

export class dataModel {
    title: string;
    title1: string;
    logo: string;
    //coverQuote: string;
    socialMedia: Social[] = [];
    industries: Industries[] = [];
    PremiumIndustries: PremiumIndustry[] = [];
    navi1: string;
    navi2: string;
    navi3: string;
    loginTitle: string;
    loginSubtitle: string;
    thankYouTitle: string;
    thankYouMessage: string;
    error404Title: string;
    error404Message: string;
    error404btn: string;
    contactEmail: string;
    popUPemail: string;
    FooterCopyrights: string;
    requestAccess: string;
    checkBoxText: string;
    termsConditionText: string;
    textGDPR: string;
    ExampleOnlineCaseStudy:  ExampleSummit[]=[];
}

export class Industry {
    name: string;
    data: PremiumIndustry[] = [];
    router: string;
    id: number;
        constructor(name, data, router, id) {
            this.name = name;
            this.data = data;
            this.router = router;
            this.id = id;
        }
}

export class Social {
    url: string;
    name: string;
}

export class Industries {
    titles: string;
    routers: string;
    videos: string;
    photos: string;
    logo: string;
    //coverQuote: string;
    caseStudies: string;
    example: ExampleSummit;
    assetId: number;

}

export class PremiumIndustries {
    data: PremiumIndustry[] = [];
}

export type Premium = {

};

export class PremiumIndustry {
    name: string;
    company: string;
    possition: string;
    testimonials: string;
    video: string;
    quote: string;
    copyrights: string;
    description: string;
    logo: string;
    image: string;
    router: string;
    outterRouter: string;
    title: string;
    db: Array<any>;
    CompanyName: string;
    CompanyType: string;
    id: number;
    routerID: string;
    videoURL: string;
    Id: number;
    CastStudyType: string;
}
export class ExampleSummit {
    name: string;
    company: string;
    possition: string;
    testimonials: string;
    video: string;
    quote: string;
    copyrights: string;
    description: string;
    logo: string;
    image: string;
    router: string;
    outterRouter: string;
    title: string;
    db: Array<any>;
    CompanyName: string;
    CompanyType: string;
    id: number;
    routerID: string;
    videoURL: string;
    Id: number;
    CastStudyType: string;
}
// export interface User {
//     username: string;
//     password: string;
//     token?: string;
// }

export class Routing {
  uri: Array<any> = [];
}

export class Documents {
    document: Document[] = [];
}

export class Document {
    url: string;
}

export class GoogleReca {
  status: boolean;
}

export class User {
    username: string;
    password: string;
    timestamp: number;
    token?: string;
}

